import React, { useState, useEffect } from 'react'
import './App.css'
import TSXScreener from './components/TSXScreener'
import { TrendingUp, BarChart3, Filter, Search } from 'lucide-react'

function App() {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setIsLoading(false)
    }, 1000)

    return () => clearTimeout(timer)
  }, [])

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <h2>Loading TSX Screener...</h2>
        <p>Analyzing Toronto Stock Exchange data</p>
      </div>
    )
  }

  return (
    <div className="app">
      <header className="app-header">
        <div className="header-content">
          <div className="logo">
            <TrendingUp className="logo-icon" />
            <h1>TSX Screener</h1>
          </div>
          <div className="header-features">
            <div className="feature">
              <Search className="feature-icon" />
              <span>Advanced Filtering</span>
            </div>
            <div className="feature">
              <BarChart3 className="feature-icon" />
              <span>Real-time Data</span>
            </div>
            <div className="feature">
              <Filter className="feature-icon" />
              <span>Custom Metrics</span>
            </div>
          </div>
        </div>
      </header>
      
      <main className="app-main">
        <TSXScreener />
      </main>
      
      <footer className="app-footer">
        <p>&copy; 2024 TSX Screener. Powered by frobuclabs.com</p>
      </footer>
    </div>
  )
}

export default App 